var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "play-icon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 78.02 71.75"
      }
    },
    [
      _c("path", {
        attrs: {
          id: "svzfb",
          d:
            "M1.66,20.24C-5.62,36.65,12.7,67.17,24.39,71s39.41-8.4,47.28-22.31,9.73-43.44-2-47.3S10.25.86,1.66,20.24Z"
        }
      }),
      _c("polygon", {
        attrs: {
          fill: "#fff",
          id: "svzfb",
          points: "44.6 34.65 35.55 29.43 35.55 39.87 44.6 34.65"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f82e111", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f82e111","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_SVG/PlayVideoIcon.vue
// module id = fp74
// module chunks = 0